module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('h2', {
    staticClass: "cn",
    attrs: {
      "id": "_idParaDest-8"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor007"
    }
  }), _c('a', {
    attrs: {
      "href": "#/text/9780062934864_Contents#r_idParaDest-8"
    }
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_15",
      "title": "15"
    }
  }, [_vm._v("Chapter Four")])])]), _vm._v(" "), _c('h2', {
    staticClass: "ct"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor008"
    }
  }), _c('a', {
    attrs: {
      "href": "#/text/9780062934864_Contents#r_idParaDest-8"
    }
  }, [_vm._v("CeCe")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("T")]), _vm._v("he music is so loud Sofia practically has to yell for me to hear. “I can’t believe we’re really here.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I shrug as if it’s not a big deal, even though it’s the biggest deal—and the biggest lie I’ve ever told my dad.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“My fair Juliet!” Heads turn and it feels like there’s a spotlight on me as Liam slides off the kitchen island where he was perched above a group of girls. I almost died when Mrs. Katz announced that the two of us would be playing the leads in the spring play. “I didn’t think you were going to make it,” Liam says.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’m not officially here,” I say, grateful Sofia had the idea for me to spend the night at her house. It almost didn’t work since I’d already told Dad her parents were letting her go, but I covered it up by saying she didn’t want to go without me. I told him it was a best-friend thing and he actually bought it. One benefit of having a workaholic mom: if she were home, she would’ve seen right through my lie.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_16",
      "title": "16"
    }
  }, [_vm._v("Liam gives me a hug and I breathe in the woodsy scent of his cologne. He shifts, leaving one arm draped heavily on my shoulder. “Want a beer?”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I hesitate, but Sofia answers for us both. “We’d love one.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I’ve had a crush on Liam Donnelly for the last four years, from the moment I spotted him on the first day of middle school. As an eighth grader, he was up onstage at orientation with all the other club presidents, telling my entire class about the drama club. But it felt like he was just talking to me. I signed up, of course, and got to spend an hour every Thursday after school in a room with Liam doing acting exercises and improv games. But the spring play was the first time we’d be onstage, playing opposite each other.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Great party,” I tell him as he hands us both our beers.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It is now that you’re here.” He smiles a crooked smile, and a flock of butterflies take flight in my stomach.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Bella just got here,” Sofia says, even though Bella was the first one we saw when we walked in. “I’m going to say hi.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I mouth a silent thank-you in her direction. When I turn back, Liam is looking at me and I’m seriously worried I might turn into a puddle. I glance away, down at the red Solo cup in my hands. The foam has gone down a bit, so I take a sip and try not to gag. I don’t understand why people like beer.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I love this song,” I say because I can’t think of anything else. Liam and I have had tons of conversations before, but they’re always about something specific, usually related to drama club. I need a script for this sort of thing.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Then let’s dance.” Liam grabs my free hand and leads me into the living room where the couches have been pushed back against the wall to create a makeshift dance floor.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I take another sip and attempt to keep rhythm with my "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_17",
      "title": "17"
    }
  }, [_vm._v("hips. I’m not a good dancer when choreography isn’t involved. But then his hand is on my waist and we’re swaying in sync with the music and each other. His skin feels warm beneath the faded T-shirt that’s so soft I wish I could wrap myself up in it, and when his chocolate-brown eyes focus on mine, I don’t look away.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Liam and I keep dancing through the next three songs, getting a little closer with each one. I bite my lip in anticipation when a slow song starts to play. I push my glasses up and smile, my eyes meeting his.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’m going to get us some more beer,” he says.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I try not to look disappointed, but the place where his hand used to be feels empty. I look stupid standing there alone, so I make my way to the edge of the room, trying not to stare at the couple making out right there in front of everybody. The guy’s hands are literally in the back pockets of the girl’s jeans and his tongue is most definitely in her mouth. I didn’t think it was possible to be so grossed out and jealous at the same time.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Liam finds me leaning against the fireplace. “Your beer, m’lady.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Feeling a little braver now, I finish almost half of the glass in one gulp.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Shall we?” He nods toward the dance floor. The slow song is still playing, but it’s got to be close to the end. He reaches for my beer, but I stop him, taking another big sip first.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Liam nods his approval and I hiccup before handing it over. He leaves our cups on the fireplace mantel and leads me to the dance floor.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("We’re swaying back and forth, and I’m on the edge of feeling lost in the moment, when my stupid glasses start slipping "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_18",
      "title": "18"
    }
  }, [_vm._v("down my nose. I squinch my face, hoping they’ll go back up on their own so we don’t have to stop dancing, not even for a second.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Liam must notice, because he takes a hand off my waist to push them back up for me. “You’re cute,” he says.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“So are you.” I feel my cheeks turning red, but I’m not sure if it’s from the beer or because he’s looking at me like I’m the only girl in the room.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The song stops playing and another slow one starts. A playlist faux pas, but I’m grateful for the mistake. I step a little closer, he holds my waist a little tighter, and I try to memorize this moment so I can remember it for the rest of my life.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He bends down and I try not to shiver as his lips brush against my ear. “I’m glad you’re my Juliet.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’m glad you’re my Romeo.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“We should probably start practicing for that final scene.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The kiss happens in the middle of the play, but I don’t correct him. It’s the only part I’ve been worrying about—if I look like I don’t know what I’m doing, everyone will find out that I’m probably the only girl in ninth grade who hasn’t been kissed. Sofia’s the only one who knows my secret. And Beau, but he doesn’t count since he doesn’t go to our school, or even live in the same state.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Mrs. Katz said we were just going to pretend.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“She said we "), _c('i', [_vm._v("could")]), _vm._v(" pretend, or we could really kiss if we wanted to.” Liam leans back a little and I look up at him. I’m trying really hard to look at his eyes and not his lips, "), _c('i', [_vm._v("but his lips")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Don’t you want to?” He tucks a strand of hair behind my ear.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I look away for a second, but when I glance back up, Liam is leaning toward me. I can’t believe this is about to happen. "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_19",
      "title": "19"
    }
  }, [_vm._v("I hope Sofia is seeing this. Actually, maybe it’s better if she doesn’t in case I don’t do it right. I hope I do it right. His eyes are closed and he’s getting closer. My heart is beating faster than the music. And then—")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Cecelia!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('i', [_vm._v("No, no, no. Please, no.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Cecelia,” my dad says again. “In the car. Now.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I drop my arms from around Liam’s neck and step back. The whole room has gone silent except for the whispers. This can’t be happening.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Say goodbye, Cecelia.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("To my social life.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-30b12639","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/9780062934864_Chapter_4.vue
// module id = 78
// module chunks = 0